import webConfig from '../configs/web.config';

// 获取能力列表
export const getAbilities = async (params) => {
  const { appId, curPage, pageSize } = params;
  try {
    const res = await fetch(`${webConfig.getAbilitiesUrl}?appId=${appId}&curPage=${curPage}&pageSize=${pageSize}`, {
      method: "get",
    })
    return res || {};
  } catch {
    return {}
  }
};

// 添加应用能力
export const addAbility = async (params) => {
  try {
    const res = await fetch(webConfig.addAbilityUrl, {
      method: "POST",
      body: JSON.stringify(params)
    })
    return res || {};
  } catch {
    return {}
  }
};

// 已开通能力菜单
export const getabilitiesMenu = async (appId) => {
  try {
    const res = await fetch(`${webConfig.getabilitiesMenuUrl}?appId=${appId}`, {
      method: "get",
    })
    return res || {};
  } catch {
    return {}
  }
};